import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// Assets (Giữ nguyên các đường dẫn của bạn)
import KyquansanTourW from './image/team_tour/kyquansan_w.jpg';
import TachinhuTour from './image/team_tour/tachinhu.jpg';
import NhiucosanTour from './image/team_tour/nhiucosan.jpg';
import LungcungTour2 from './image/team_tour/lungcung_2.jpg';
import TaxuaTour from './image/team_tour/taxua.jpg';
import LaothanTour from './image/team_tour/laothan.jpg';
import TaliensonTour from './image/team_tour/talienson.jpg';
import PutalengTour from './image/team_tour/putaleng.jpg';
import SamuTour from './image/team_tour/samu.jpg';
import BackImage from './image/team_tour/back_m.png';

// 1. Component TourCard: Tối ưu cho thao tác vuốt chạm trên di động
const MobilePremiumTourCard = ({ title, height, distance, duration, cost, participants, image, reverse = false }) => (
  <div className="flex flex-col w-full my-8 overflow-hidden rounded-[40px] bg-white shadow-xl border border-slate-100 antialiased">
    
    {/* Visual Side: Tăng độ tương phản để chữ tiêu đề sắc nét */}
    <div className="w-full relative aspect-[4/3] overflow-hidden">
      <img 
        loading="lazy" 
        src={image} 
        alt={title} 
        className="w-full h-full object-cover" 
      />
      {/* Lớp phủ gradient tối giúp chữ trắng cực kỳ nổi bật */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
      <div className="absolute bottom-6 left-6 right-6">
        <span className="text-[10px] tracking-[0.3em] uppercase text-white/70 mb-1 block">Chinh phục đỉnh cao</span>
        <h2 className="text-4xl font-black tracking-tighter uppercase text-white leading-none drop-shadow-lg">{title}</h2>
      </div>
    </div>
    
    {/* Service Side: Trình bày thông tin dịch vụ sạch sẽ */}
    <div className="w-full p-8 flex flex-col justify-between bg-white">
      <div className="space-y-4">
        <div className="flex justify-between items-end border-b border-slate-50 pb-3">
          <span className="text-slate-400 text-[10px] uppercase tracking-widest font-bold">Độ cao</span>
          <span className="text-xl font-black text-slate-800">{height}</span>
        </div>
        <div className="flex justify-between items-end border-b border-slate-50 pb-3">
          <span className="text-slate-400 text-[10px] uppercase tracking-widest font-bold">Cung đường</span>
          <span className="text-lg font-bold text-slate-700">{distance}</span>
        </div>
        <p className="text-xs text-slate-500 italic leading-relaxed font-medium">
          {duration}
        </p>
      </div>

      <div className="mt-8">
        <div className="mb-5">
          <span className="text-[10px] text-sky-600 font-black uppercase tracking-[0.2em]">Giá dịch vụ trọn gói</span>
          <p className="text-3xl font-black text-slate-900 mt-1">{cost}</p>
          <p className="text-[10px] text-slate-400 mt-1 uppercase tracking-wider font-bold">Nhóm tiêu chuẩn {participants} người</p>
        </div>
        
        <button 
          onClick={() => window.open('https://www.facebook.com/leminhofhaiduong')}
          className="w-full py-4 bg-slate-900 text-white rounded-2xl font-black uppercase tracking-widest text-[10px] active:scale-95 transition-all shadow-lg">
          Đặt chỗ ngay
        </button>
      </div>
    </div>
  </div>
);

// 2. Component giới thiệu triết lý dịch vụ (Tối ưu dạng cột cho mobile)
const MobileServicePhilosophy = () => (
  <div className="w-full flex flex-col gap-4 my-10">
    <div className="p-8 bg-white/80 backdrop-blur-xl rounded-[30px] border border-white shadow-lg">
      <h3 className="text-sky-600 font-black text-lg mb-2 uppercase tracking-tight">Sức khỏe là ưu tiên</h3>
      <p className="text-slate-600 text-sm leading-relaxed italic font-medium">
        "EASY TREK được thiết kế để bạn có thể trạng tốt nhất, trọn vẹn sức lực dành cho việc chinh phục thay vì mệt mỏi bởi hành lý."
      </p>
    </div>
    <div className="p-8 bg-slate-900 text-white rounded-[30px] shadow-2xl">
      <h3 className="text-orange-400 font-black text-lg mb-2 uppercase tracking-tight">Riêng tư là trên hết</h3>
      <p className="text-slate-300 text-sm leading-relaxed italic font-light">
        Tận hưởng giấc ngủ ngon tại homestay, di chuyển oto riêng tư, xe ôm xuyên bản và có porter hỗ trợ tối đa.
      </p>
    </div>
  </div>
);

export default function HotTourTeamMobile() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="relative min-h-screen font-sans bg-[#F8F9FA] antialiased"
      style={{ backgroundImage: `url(${BackImage})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
      
      {/* Lớp phủ toàn trang giúp chữ trắng không bị chìm vào nền ảnh */}
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px] z-0"></div>

      <div className="relative z-10 flex flex-col items-center w-full px-5 py-24">
        
        {/* Header Section phong cách Resort Luxury cho Mobile */}
        <header className="text-center mb-10">
          <span className="text-sky-400 font-black tracking-[0.4em] uppercase text-[10px] mb-3 block drop-shadow-md">The Experience</span>
          <h1 className="text-6xl font-black text-white mb-4 tracking-tighter uppercase leading-none drop-shadow-2xl">
            EASY <span className="text-sky-400 italic font-serif">TREK</span>
          </h1>
          <p className="text-sm text-white/90 max-w-xs mx-auto font-medium italic leading-relaxed drop-shadow-md">
            "Ngàn thước lên cao, ngàn thước xuống."
          </p>
        </header>

        <MobileServicePhilosophy />

        {/* Danh sách Tour - Hiển thị dạng thẻ dọc */}
        <div className="w-full space-y-2">
            <MobilePremiumTourCard
              title="TÀ CHÌ NHÙ"
              height="2979m"
              distance="26KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={TachinhuTour}
            />

            <MobilePremiumTourCard
              title="NHÌU CỒ SAN"
              height="2965m"
              distance="28KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={NhiucosanTour}
              reverse
            />

            <MobilePremiumTourCard
              title="KỲ QUAN SAN"
              height="3046m"
              distance="34KM"
              duration="18h tối thứ năm đến 23h tối chủ nhật"
              cost="5.500.000 VNĐ/Người"
              participants="10-20"
              image={KyquansanTourW}
            />

            <MobilePremiumTourCard
              title="LÙNG CÚNG"
              height="2913m"
              distance="26KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={LungcungTour2}
              reverse
            />

            <MobilePremiumTourCard
              title="LẢO THẨN"
              height="2860m"
              distance="24KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={LaothanTour}
            />

            <MobilePremiumTourCard
              title="TÀ XÙA"
              height="2865m"
              distance="26KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={TaxuaTour}
              reverse
            />

            <MobilePremiumTourCard
              title="TẢ LIÊN SƠN"
              height="2996m"
              distance="28KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="5.500.000 VNĐ/Người"
              participants="10-20"
              image={TaliensonTour}
            />

            <MobilePremiumTourCard
              title="PUTALENG"
              height="3083m"
              distance="36KM"
              duration="18h tối thứ năm đến 23h tối chủ nhật"
              cost="5.500.000 VNĐ/Người"
              participants="10-20"
              image={PutalengTour}
              reverse
            />

            <MobilePremiumTourCard
              title="SAMU"
              height="2856m"
              distance="28KM"
              duration="18h tối thứ sáu đến 23h tối chủ nhật"
              cost="4.500.000 VNĐ/Người"
              participants="10-20"
              image={SamuTour}
            />
        </div>

        {/* Footer */}
        <footer className="mt-20 mb-6 text-center">
            <div className="h-[1px] w-12 bg-white/20 mx-auto mb-6"></div>
            <p className="text-white/40 text-[9px] tracking-[0.4em] uppercase font-bold">
                © 2026 Keep Going Trek — Art of Service
            </p>
        </footer>
      </div>
    </div>
  );
}